import { RelativePosition } from '@com/components/timeline-panel/utils/track-insert-position'
import { IvNodeUuid, IvSegment, IvTrack } from '../types'
import { getTimelineBySceneUuid } from '../timeline'
import { useTrackGroupInsertResultsByDiffV2 } from './track-group-insert-v2'
import { IvTrackType } from '../enums'
export { findHasSegmentTrack, hasSegmentTrack } from './track-group-insert-v2'

type TrackGroupInsertResultFn = () => void
export interface TrackGroupInsertResult {
  // 一定会有值的
  to: IvSegment['groupId']
  position: RelativePosition
  from: IvSegment['groupId'] | undefined
  nodeUuid: IvNodeUuid
  // to groupId 对应的轨道类型，为了避免消费端消费to groupId为空时候，可以通过 该值判断是iv/video轨道，来定义相应的行为
  typeOfToTrack: IvTrackType | undefined
}

export function useTrackGroupInsertResults(
  sceneUuid: IvSegment['sceneUuid'],
  fn: TrackGroupInsertResultFn,
): TrackGroupInsertResult[] {
  const oldTracks = getTimelineBySceneUuid(sceneUuid)
  fn()
  const newTracks = getTimelineBySceneUuid(sceneUuid)

  return useTrackGroupInsertResultsByDiff(sceneUuid, newTracks, oldTracks)
}

export function useTrackGroupInsertResultsByDiff(
  sceneUuid: IvSegment['sceneUuid'],
  newTracks: IvTrack[],
  oldTracks: IvTrack[],
): TrackGroupInsertResult[] {
  const v2Results = useTrackGroupInsertResultsByDiffV2(
    sceneUuid,
    newTracks,
    oldTracks,
  )

  return v2Results.reduce<TrackGroupInsertResult[]>((results, r) => {
    const { to, position, targets: _targets } = r

    /**
     * 最外层的先执行
     * eg: [t1, t2, t3] to t0 bottom
     * inset t3:
     * to
     * |
     * to3
     * inset t2:
     * to
     * |
     * to2
     * |
     * to3
     * inset t1:
     * to
     * |
     * to1
     * |
     * to2
     * |
     * to3
     */
    const targets = [..._targets].reverse()
    targets.forEach((targetTrack) => {
      targetTrack.nodes.forEach((node) => {
        results.push({
          to,
          position,
          from: node.from,
          nodeUuid: node.uuid,
          typeOfToTrack: targetTrack.type,
        })
      })
    })

    return results
  }, [])
}
